import type { Node, NodeProps } from '@xyflow/react';
import { CogIcon } from '@heroicons/react/24/outline';
import { Badge } from '../../../catalyst/badge';
import { nodeLabel } from '../graphModel';
import { chevronProps, type FlowNodeData } from '../useGraphLayout';
import { KIND_PALETTE } from '../kindPalette';
import { FootLine } from './FootLine';
import { NodeShell } from './NodeShell';

export function EngineNode({ data }: NodeProps<Node<FlowNodeData>>) {
  if (data.node.kind !== 'engine') return null;
  const { esn, engineType, isWorkingEngine, role } = data.node;
  return (
    <NodeShell
      icon={CogIcon}
      iconClassName="text-indigo-600 dark:text-indigo-400"
      compactClassName={KIND_PALETTE.engine.compact}
      label={nodeLabel(data.node)}
      selected={data.selected}
      focused={data.focused}
      {...chevronProps(data)}
      className="w-50"
    >
      {/* The ESN is the identifier: it wraps, never truncates. The badge sits on its own line. */}
      <div className="text-sm font-medium break-words">ESN {esn}</div>
      {isWorkingEngine ? (
        <div>
          <Badge color="indigo">working</Badge>
        </div>
      ) : (
        role === 'donor' && (
          <div>
            <Badge color="zinc">donor</Badge>
          </div>
        )
      )}
      <FootLine text={engineType} mentions={data.mentions} />
    </NodeShell>
  );
}
